"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),t=require("react"),a=require("prop-types"),l=require("@vds-tokens/color"),r=require("@vds-core/utilities");function o(e){return e&&e.__esModule?e:{default:e}}var d=o(e),i=o(t),s=o(a);const u=r.calculateRem("10px"),c=l.ColorTokens.elements.primary.onlight.value,n=l.ColorTokens.elements.primary.ondark.value,f=l.ColorTokens.interactive.disabled.onlight.value,b=l.ColorTokens.interactive.disabled.ondark.value,p={disabled:s.default.bool,height:s.default.number,width:s.default.number,selected:s.default.bool,surface:s.default.oneOf(["light","dark"]),checked:s.default.bool},h={disabled:!1,height:20,width:20,surface:"light"},m=d.default.div.withConfig({displayName:"StyledWrapper",componentId:"VDS__sc-uj1g8o-0"})`
  box-sizing: border-box;
`,g=d.default.div.withConfig({displayName:"StyledOuterCircle",componentId:"VDS__sc-uj1g8o-1"})`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: ${r.calculateRem(20)};
  justify-content: center;
  left: ${r.calculateRem(-20)};
  position: absolute;
  right: 0;
  top: 0;
  width: ${r.calculateRem(20)};
  box-sizing: border-box;
`,k=d.default.div.withConfig({displayName:"StyledInnerCircle",componentId:"VDS__sc-uj1g8o-2"})`
  background-color: ${({surface:e})=>"dark"===e?n:c};
  border-radius: 50%;
  height: ${u};
  width: ${u};
  position: absolute;

  ${({disabled:e,surface:t})=>e&&`\n  background-color: ${"dark"===t?b:f}`}
`,v=e=>{const{disabled:t,surface:a}=e,l=e.checked||e.selected||!1;return i.default.createElement(m,null,i.default.createElement(g,Object.assign({},e,{className:"radioOuter",focusable:"false","aria-hidden":!0,surface:a,selected:l}),l&&i.default.createElement(k,{disabled:t,surface:a})))};v.defaultProps=h,v.propTypes=p,exports.default=v;



//////////////////
// WEBPACK FOOTER
// ./~/@vds-core/radio-buttons/cjs/components/RadioButtonIcon.js
// module id = 1179
// module chunks = 0